function Map() {  
    return(
        <div className='google-wrapper'>
            <div className='title'>찾아오시는 길</div>
            <iframe 
                title='google'
                src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.8057153994387!2d126.82873641612208!3d37.5596409322789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9d0dbcca6e13%3A0x921c5aa6b1efc252!2z7ISc7Jq47Yq567OE7IucIOqwleyEnOq1rCDqs7Xtla3rjIDroZwgMjA5!5e0!3m2!1sko!2skr!4v1676472858529!5m2!1sko!2skr'
            />
        </div>
    );
}

export default Map;